import { render, staticRenderFns, recyclableRender, components } from "./pw-swiper.vue?vue&type=template&id=48fec020&scoped=true&filter-modules=eyJyanMiOnsidHlwZSI6InJlbmRlcmpzIiwiY29udGVudCI6IiIsInN0YXJ0IjoxMTk2LCJhdHRycyI6eyJtb2R1bGUiOiJyanMiLCJsYW5nIjoianMifSwiZW5kIjoxNjY1fSwid3hzIjp7InR5cGUiOiJzY3JpcHQiLCJjb250ZW50IjoidmFyIHRvdWNoU3RhcnRPYmogPSB7fVxubW9kdWxlLmV4cG9ydHMudG91Y2hTdGFydCA9ZnVuY3Rpb24gKGUpIHtcblx0dG91Y2hTdGFydE9iaiA9IGUudG91Y2hlc1swXTtcbn1cbm1vZHVsZS5leHBvcnRzLnRvdWNoTW92ZSA9IGZ1bmN0aW9uKGUsaW5zdGFuY2Upe1xuXHR2YXIgbW92ZU9iaiA9IGUudG91Y2hlc1swXTtcblx0dmFyIGRhdGFzZXQgPSBlLmluc3RhbmNlLmdldERhdGFzZXQoKVxuXHR2YXIgY3VycmVudCA9IGRhdGFzZXQuY3VycmVudFxuXHR2YXIgdmVydGljYWwgPSBkYXRhc2V0LnZlcnRpY2FsXG5cdHZhciBkYXRhTGVuZ3RoID0gZGF0YXNldC5kYXRhTGVuZ3RoXG5cdHZhciBwcmVEaXIgPSB2ZXJ0aWNhbCA%2FIG1vdmVPYmouY2xpZW50WSAtIHRvdWNoU3RhcnRPYmouY2xpZW50WSA%2BIDAgOiBtb3ZlT2JqLmNsaWVudFggLSB0b3VjaFN0YXJ0T2JqLmNsaWVudFggPiAwXG5cdHZhciBuZXh0RGlyID0gdmVydGljYWwgPyBtb3ZlT2JqLmNsaWVudFkgLSB0b3VjaFN0YXJ0T2JqLmNsaWVudFkgPCAwIDogbW92ZU9iai5jbGllbnRYIC0gdG91Y2hTdGFydE9iai5jbGllbnRYIDwgMFxuXHRpZihjdXJyZW50PT0wJiZwcmVEaXIpe1xuXG5cblxuXG5cdFx0cmV0dXJuIGZhbHNlXG5cblx0fWVsc2UgaWYoY3VycmVudD09ZGF0YUxlbmd0aC0xJiZuZXh0RGlyKXtcblxuXG5cblxuXHRcdHJldHVybiBmYWxzZVxuXG5cdH1cbn0iLCJzdGFydCI6MTcwOCwiYXR0cnMiOnsibW9kdWxlIjoid3hzIiwibGFuZyI6Ind4cyJ9LCJlbmQiOjI2MjB9fQ%3D%3D&"
var renderjs
import script from "./pw-swiper.vue?vue&type=script&lang=js&"
export * from "./pw-swiper.vue?vue&type=script&lang=js&"
import style0 from "./pw-swiper.vue?vue&type=style&index=0&id=48fec020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fec020",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./pw-swiper.vue?vue&type=custom&index=0&blockType=script&module=wxs&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "uni_modules/uce-q-bank/components/pw-swiper/pw-swiper.vue"
export default component.exports